import {
  Alert,
  alpha,
  Box,
  Button,
  Card,
  CardActionArea,
  Chip,
  CircularProgress,
  Divider,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Paper,
  Select,
  Stack,
  SvgIcon,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { withRouter } from 'react-router';
import { getYears } from '../../../helpers/dateHelpers';
import { useEffect, useState, Fragment } from 'react';
import { getScheduleFacility2, getScheduleMetrics, getStates } from '../../../helpers/api';
import MUIDataTable from 'mui-datatables';
import LoaderSkeleton from '../../common/LoaderSkeleton';
import { Empty } from 'antd';
import {
  CalendarMonthOutlined,
  Close,
  EventAvailableOutlined,
  EventBusyOutlined,
  FilterAltOutlined,
  MoreHoriz,
  PieChartOutline,
  Search,
  BusinessRounded,
  LocationOnOutlined,
  CalendarTodayOutlined,
} from '@mui/icons-material';
import QaqcPlannerQuarterDialog from './qaqcplanner-quarter/QaqcPlannerQuarterDialog';
import { openNotification } from '../../../helpers/notification';
import AppPagination from '../../common/AppPagination';
import SchedulerDialog from '../facilities2/view-facility/scheduler-dialogs/SchedulerDialog';
import { ReactComponent as CalenderIcon } from '../../../assets/img/calendar-18.svg';
import { Link } from 'react-router-dom';

const QaqcPlannerScreen = withRouter(({ props, history }) => {
  const years = getYears();
  const currentYear = new Date().getFullYear();

  const quarterList = [
    { id: 'unreservedQuarter', value: 0, label: 'Unreserved', duration: 'Not yet assigned' },
    { id: 'firstQuarter', value: 1, label: 'First Quarter', duration: 'Jan - Mar' },
    { id: 'secondQuarter', value: 2, label: 'Second Quarter', duration: 'Apr - Jun' },
    { id: 'thirdQuarter', value: 3, label: 'Third Quarter', duration: 'Jul - Sep' },
    { id: 'fourthQuarter', value: 4, label: 'Fourth Quarter', duration: 'Oct - Dec' },
  ];

  const initQuarter = quarterList.find((x) => x.value === 0).value;
  const pageSize = 10;
  const [pageNum, setPageNum] = useState(0);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [planList, setPlanList] = useState([]);
  const [planLoading, setPlanLoading] = useState(false);
  const [planSelected, setPlanSelected] = useState();
  const [planRefresh, setPlanRefresh] = useState(false);
  const [planTotal, setPlanTotal] = useState(0);
  const [quarterSelected, setQuarterSelected] = useState(initQuarter);
  const [facilitiesSelected, setFacilitiesSelected] = useState([]);
  const [menuEl, setMenuEl] = useState(null);
  const [quarterDialog, setQuarterDialog] = useState(false);
  const [scheduleDialog, setScheduleDialog] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const [stateSelected, setStateSelected] = useState('');
  const [scheduleMetrics, setScheduleMetrics] = useState();
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchStates();
  }, []);
  useEffect(() => {
    fetchQaqcPlan();
  }, [search, selectedYear, stateSelected, quarterSelected, pageNum]);
  useEffect(() => {
    fetchScheduleMetrics();
  }, [selectedYear, stateSelected, planRefresh]);

  useEffect(() => {
    if (planRefresh) fetchQaqcPlan();
  }, [planRefresh]);

  const handleOverflowMenuClick = (event) => setMenuEl(event.currentTarget);
  const handleCloseMenu = () => setMenuEl(null);

  const fetchStates = async () => {
    setStateLoading(true);
    try {
      const res = await getStates();
      const { data, status } = res?.result;
      if (status?.code === '00') setStateList(data);
    } catch (error) {
      console.error(error);
    } finally {
      setStateLoading(false);
    }
  };

  const fetchQaqcPlan = async () => {
    setPlanLoading(true);
    try {
      const res = await getScheduleFacility2(
        search,
        selectedYear,
        quarterSelected,
        stateSelected,
        '',
        pageNum,
        pageSize
      );
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setPlanList(data);
        setPlanTotal(res?.total);
      }
    } catch (error) {
      openNotification({
        type: 'error',
        message: error?.data?.result?.data?.status?.desc || 'Error fetching plan',
      });
    } finally {
      setPlanLoading(false);
      setPlanRefresh(false);
    }
  };

  const fetchScheduleMetrics = async () => {
    try {
      const res = await getScheduleMetrics(selectedYear, stateSelected);
      const { data, status } = res?.result;
      if (status?.code === '00') setScheduleMetrics(data);
    } catch (error) {
      console.error(error);
    } finally {
      setPlanRefresh(false);
    }
  };

  const renderQuarters = () => (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        overflowX: 'auto',
        pb: 1,
        '&::-webkit-scrollbar': { height: 6 },
        '&::-webkit-scrollbar-thumb': { bgcolor: alpha('#000', 0.1), borderRadius: 3 },
      }}
    >
      {quarterList?.map((i) => {
        const isSelected = quarterSelected === i.value;
        return (
          <Card
            key={i.value}
            elevation={0}
            sx={{
              border: '1px solid',
              borderColor: isSelected ? 'primary.main' : 'divider',
              bgcolor: isSelected ? alpha('#1976d2', 0.05) : '#fff',
              minWidth: '190px',
              flex: 1,
              borderRadius: '16px',
              transition: '0.3s',
            }}
          >
            <CardActionArea
              sx={{ p: 2, textAlign: 'center' }}
              onClick={() => setQuarterSelected(i.value)}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: '12px',
                    bgcolor: isSelected ? 'primary.main' : alpha('#1976d2', 0.1),
                    color: isSelected ? '#fff' : 'primary.main',
                    display: 'flex',
                  }}
                >
                  <CalendarTodayOutlined sx={{ fontSize: 24 }} />
                </Box>
              </Box>
              <Typography
                variant="body2"
                fontWeight={700}
                color={isSelected ? 'primary.main' : 'textPrimary'}
              >
                {i.label}
              </Typography>
              <Typography
                component={'div'}
                variant="caption"
                color="textSecondary"
                fontWeight={500}
              >
                {i.duration}
              </Typography>
              {scheduleMetrics && (
                <Chip
                  label={`${scheduleMetrics[i.id] || 0} Facilities`}
                  size="small"
                  sx={{
                    mt: 1.5,
                    height: 20,
                    fontSize: '0.65rem',
                    fontWeight: 700,
                    bgcolor: isSelected ? 'primary.main' : alpha('#000', 0.05),
                    color: isSelected ? '#fff' : 'text.primary',
                  }}
                />
              )}
            </CardActionArea>
          </Card>
        );
      })}
    </Box>
  );

  const renderContent = () => {
    const columns = [
      {
        name: 'facilityName',
        label: 'Facility Details',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => (
            <Stack direction="row" spacing={2} alignItems="center">
              <Box
                sx={{
                  p: 1,
                  borderRadius: '10px',
                  bgcolor: alpha('#1976d2', 0.1),
                  color: 'primary.main',
                  display: 'flex',
                }}
              >
                <BusinessRounded sx={{ fontSize: 18 }} />
              </Box>
              <Link
                to={`/facilities/${planList[index].facilityId}/view`}
                style={{ textDecoration: 'none' }}
              >
                <Typography
                  variant="body2"
                  fontWeight={700}
                  color="primary"
                  sx={{ '&:hover': { textDecoration: 'underline' } }}
                >
                  {planList[index].facilityName}
                </Typography>
              </Link>
            </Stack>
          ),
        },
      },
      {
        name: 'stateName',
        label: 'Location',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => (
            <Stack direction="row" spacing={0.5} alignItems="center">
              <LocationOnOutlined sx={{ fontSize: 16, color: 'text.disabled' }} />
              <Typography variant="body2" fontWeight={500}>
                {planList[index].stateName}
              </Typography>
            </Stack>
          ),
        },
      },
      {
        name: 'address',
        label: 'Address',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => (
            <Tooltip title={planList[index].address}>
              <Typography variant="body2" color="textSecondary" noWrap sx={{ maxWidth: 200 }}>
                {planList[index].address}
              </Typography>
            </Tooltip>
          ),
        },
      },
      {
        name: 'scheduleDate',
        label: 'QAQC Schedule',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => (
            <Chip
              label={
                planList[index].scheduleDate
                  ? new Date(planList[index].scheduleDate).toLocaleDateString('en-NG', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                    })
                  : 'Not Scheduled'
              }
              size="small"
              variant="outlined"
              sx={{
                fontWeight: 600,
                fontSize: '0.7rem',
                border: '1px solid',
                borderColor: planList[index].scheduleDate ? 'info.light' : 'divider',
                color: planList[index].scheduleDate ? 'info.main' : 'text.disabled',
              }}
            />
          ),
        },
      },
      {
        name: '',
        label: 'Actions',
        options: {
          customHeadLabelRender: (a) => (
            <Typography
              variant="button"
              fontWeight={700}
              color="text.secondary"
              sx={{ fontSize: '0.75rem' }}
              align="center"
            >
              {a.label}
            </Typography>
          ),
          customBodyRenderLite: (index) => (
            <Box align="center">
              <IconButton
                size="small"
                onClick={(e) => {
                  handleOverflowMenuClick(e);
                  setPlanSelected(planList[index]);
                }}
                sx={{ bgcolor: alpha('#000', 0.03) }}
              >
                <MoreHoriz />
              </IconButton>
            </Box>
          ),
        },
      },
    ];

    return (
      <MUIDataTable
        data={planList}
        columns={columns}
        options={{
          elevation: 0,
          search: false,
          filter: false,
          download: false,
          print: false,
          viewColumns: false,
          selectableRows: 'multiple',
          responsive: 'standard',
          pagination: false,
          onRowSelectionChange: (rows, allRows) =>
            setFacilitiesSelected(allRows.map((r) => planList[r.index])),
          customToolbarSelect: () => (
            <Button
              variant="contained"
              size="small"
              disableElevation
              startIcon={<EventAvailableOutlined />}
              sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 700, mr: 3 }}
              onClick={() => setQuarterDialog(true)}
            >
              Batch Reserve ({facilitiesSelected.length})
            </Button>
          ),
          setRowProps: (ev, dataIndex) => ({
            style: { backgroundColor: dataIndex % 2 === 0 ? '#ffffff' : alpha('#f5f7ff', 0.5) },
          }),
          setTableProps: () => ({ size: 'small' }),
        }}
      />
    );
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#F4F6F8', minHeight: '100vh', mt: -1 }}>
      {/* FILTER & METRIC HEADER */}
      <Paper
        elevation={0}
        sx={{ p: 2, mb: 3, borderRadius: '16px', border: '1px solid', borderColor: 'divider' }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ sm: 'center' }}
          spacing={2}
        >
          <Box>
            <Typography variant="h5" fontWeight={700} color="text.primary">
              QAQC Planning
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Reserve and schedule facility quarters for Quality Assurance.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1.5}>
            <Select
              value={stateSelected}
              size="small"
              displayEmpty
              onChange={(e) => setStateSelected(e.target.value)}
              startAdornment={
                <FilterAltOutlined sx={{ fontSize: 18, mr: 1, color: 'text.secondary' }} />
              }
              sx={{ borderRadius: '12px', minWidth: 150, bgcolor: '#f9fafb' }}
            >
              <MenuItem value="">All States</MenuItem>
              {stateList?.map((i) => (
                <MenuItem key={i.stateId} value={i.stateId} sx={{ textTransform: 'capitalize' }}>
                  {i.stateName?.toLowerCase()}
                </MenuItem>
              ))}
            </Select>
            <Select
              value={selectedYear}
              size="small"
              onChange={(e) => setSelectedYear(e.target.value)}
              sx={{ borderRadius: '12px', minWidth: 100, bgcolor: '#f9fafb', fontWeight: 600 }}
            >
              {years?.map((y) => (
                <MenuItem key={y} value={y}>
                  {y}
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </Stack>
      </Paper>

      {selectedYear < currentYear && (
        <Alert
          severity="warning"
          variant="outlined"
          sx={{ mb: 3, borderRadius: '12px', border: '1px solid', bgcolor: alpha('#ed6c02', 0.05) }}
        >
          You are viewing a past year ({selectedYear}). Schedules in this period are read-only or
          historical.
        </Alert>
      )}

      <Box sx={{ mb: 4 }}>{renderQuarters()}</Box>

      {/* SEARCH BAR */}
      <Box sx={{ display: 'flex', mb: 3 }}>
        <TextField
          placeholder="Search facility name or address..."
          size="small"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && setSearch(searchInput)}
          sx={{ width: { xs: '100%', sm: 350 } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search color="action" />
              </InputAdornment>
            ),
            endAdornment: searchInput && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => {
                    setSearchInput('');
                    setSearch('');
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
            sx: { borderRadius: '12px', bgcolor: '#fff' },
          }}
        />
      </Box>

      {/* DATA TABLE */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: '16px',
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        {planLoading ? (
          <Box sx={{ p: 4 }}>
            <LoaderSkeleton />
            <Divider sx={{ my: 3 }} />
            <LoaderSkeleton />
          </Box>
        ) : planList?.length < 1 ? (
          <Box sx={{ py: 10, textAlign: 'center' }}>
            <Empty description="No facilities found for this selection" />
          </Box>
        ) : (
          renderContent()
        )}
      </Paper>

      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="body2" color="textSecondary" fontWeight={500}>
          Total Results: {planTotal}
        </Typography>
        <AppPagination
          defaultCurrent={1}
          total={planTotal}
          onPageChange={(p) => setPageNum(p - 1)}
        />
      </Box>

      {/* OVERFLOW MENU */}
      <Menu
        anchorEl={menuEl}
        open={Boolean(menuEl)}
        onClose={handleCloseMenu}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            mt: 1,
            width: 220,
            boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
            border: '1px solid',
            borderColor: 'divider',
          },
        }}
      >
        {planSelected?.reportQuarter === 0 ? (
          <MenuItem
            onClick={() => {
              setFacilitiesSelected([planSelected]);
              setQuarterDialog(true);
              handleCloseMenu();
            }}
          >
            <EventAvailableOutlined sx={{ mr: 1.5, fontSize: 18 }} color="primary" />
            <Typography variant="body2" fontWeight={600}>
              Reserve QAQC
            </Typography>
          </MenuItem>
        ) : (
          <Fragment>
            <MenuItem onClick={handleCloseMenu}>
              <EventBusyOutlined sx={{ mr: 1.5, fontSize: 18 }} color="error" />
              <Typography variant="body2" color="error" fontWeight={600}>
                Unreserve Quarter
              </Typography>
            </MenuItem>
            <MenuItem
              onClick={() => {
                setScheduleDialog(true);
                handleCloseMenu();
              }}
            >
              <CalendarMonthOutlined sx={{ mr: 1.5, fontSize: 18 }} color="action" />
              <Typography variant="body2">
                {planSelected?.scheduleDate ? 'Reschedule' : 'Schedule Date'}
              </Typography>
            </MenuItem>
            <Divider />
            <MenuItem
              onClick={() => {
                history.push(
                  `/results/view/${planSelected?.facilityId}/${planSelected?.reportId}/${quarterSelected}/${selectedYear}`
                );
                handleCloseMenu();
              }}
            >
              <PieChartOutline sx={{ mr: 1.5, fontSize: 18 }} color="action" />
              <Typography variant="body2">Manage Results</Typography>
            </MenuItem>
          </Fragment>
        )}
      </Menu>

      {/* DIALOGS */}
      {quarterDialog && (
        <QaqcPlannerQuarterDialog
          open={quarterDialog}
          year={selectedYear}
          facilities={facilitiesSelected}
          quarterList={quarterList}
          onClose={() => {
            setQuarterDialog(false);
            setPlanRefresh(true);
          }}
        />
      )}
      {scheduleDialog && (
        <SchedulerDialog
          open={scheduleDialog}
          facilityId={planSelected?.facilityId}
          quarter={planSelected}
          onClose={() => {
            setScheduleDialog(false);
            setPlanRefresh(true);
          }}
        />
      )}
    </Box>
  );
});

export default QaqcPlannerScreen;
